module.exports = "<div ng-init=\"archive = $ctrl.archive\"> <div class=row> <div class=col-xs-12> <app-form-text view-state=true i18n-label=Book field=$ctrl.bookTitle></app-form-text> <app-form-text multiline=true view-state=true i18n-label=\"JSON Structure\" field=$ctrl.jsonStructure></app-form-text> <div class=\"form-group no-border\"> <app-widgets-label i18n-label=Download>Download</app-widgets-label> <br> <a ng-href=\"{{ archive.pdf_url }}\" target=_blank>{{ archive.pdf }}</a> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/archive/view/general/partial.html
// module id = 400
// module chunks = 0